'use client'

import { Marquee } from '@/lib/ui-kit/components/ui/Marquee.component'

interface CarouselProps {
  cards: {
    title: string
  }[]
}

export const Carousel = ({ cards }: CarouselProps) => {
  return (
    <Marquee fade direction="left">
      {cards.map((card, index) => (
        <div
          key={index}
          className="heading-s flex-shrink-0 select-none rounded-full bg-gray-50 px-6 py-4 text-center text-base-dark hover:bg-base-dark hover:text-base-light"
          style={{ minWidth: '200px' }}
        >
          {card.title}
        </div>
      ))}
    </Marquee>
  )
}
